export default "__VITE_ASSET__d02c0139__"